const IMAGE_HOST = process.env.NEXT_PUBLIC_IMAGE_HOST!

export const getImageUrl = (path: string): string =>
  `${
    IMAGE_HOST ? (IMAGE_HOST.endsWith('/') ? IMAGE_HOST : `${IMAGE_HOST}/`) : ''
  }${path}`
